import $ from 'jquery';

function FooterMods(element) {
  this.element = element;
  this.$element = $(element);
  this.init();
  this.ready();
}

FooterMods.prototype = {
  init() {
    this.$element.find('.social-links .email-destination').html(this.$element.find('.footer-contact .email'));
    this.$element.find('.footer-contact').prependTo(this.$element.find('.footer-contact-wrapper'));
  },
  ready() { this.$element.addClass('ready'); },
};

export default FooterMods;
